/**
 * Central image asset references.
 *
 * These were originally hot-linked from the scaffolding vendor's CDN
 * (static.prod-images.emergentagent.com). That was wrong on three counts: the
 * hero — the largest element on the homepage, and its LCP — sat on an origin
 * the client neither owns nor can reach if it goes away; it cost a separate DNS
 * lookup, TLS handshake and connection before the browser could even start
 * downloading; and the files were unoptimised JPEGs, 5.4 MB across the set.
 *
 * They now live in /public/img, served from the site's own domain and cached
 * alongside it, re-encoded to WebP at the sizes actually displayed: 5.4 MB down
 * to 0.47 MB with no visible quality difference.
 *
 * The CMS can still override any of these — see SiteDataContext. They are
 * defaults, not fixtures.
 */

export const IMAGES = {
  // Two widths so a phone is not sent the desktop file; see HERO_SRCSET below.
  hero: "/img/hero-v2-1200w.webp",
  about: "/img/about-1200w.webp",
  category: {
    "water-purification-systems": "/img/category-water-purification-systems.webp",
    "glassware-washers": "/img/category-glassware-washers.webp",
    "balances": "/img/category-balances.webp",
  },
  product: {
    "water-purification-systems": "/img/product-water-purification-systems.webp",
    "glassware-washers": "/img/product-glassware-washers.webp",
    "balances": "/img/product-balances.webp",
  },
  blog: {
    water: "/img/blog-water.webp",
    lab: "/img/blog-lab.webp",
  },
};

/**
 * Responsive sources for the two large editorial images.
 *
 * Only applied when the image is still the built-in default — once the CMS
 * supplies its own URL there is no 800w variant of it to offer, and pointing
 * `srcset` at a file that does not exist would break the image entirely.
 */
/**
 * The social preview card. Deliberately a 1200x630 JPEG rather than the hero
 * WebP: that is the size every platform crops to, and WhatsApp in particular
 * is still unreliable with WebP. Kept in step with prerender.js.
 */
export const OG_IMAGE = "/img/og-default-v2.jpg";

export const HERO_SRCSET = "/img/hero-v2-800w.webp 800w, /img/hero-v2-1200w.webp 1200w";
export const ABOUT_SRCSET = "/img/about-800w.webp 800w, /img/about-1200w.webp 1200w";

export const srcSetFor = (src, srcSet) => (src === IMAGES.hero || src === IMAGES.about ? srcSet : undefined);
